export function readPreviewTeam() {
  try {
    const value = JSON.parse(localStorage.getItem('previewTeamData'));
    if (value && typeof value.id === 'string' && typeof value.name === 'string')
      return value;
    if (value !== null) localStorage.removeItem('previewTeamData');
  } catch {
    try {
      localStorage.removeItem('previewTeamData');
    } catch {
      /* Storage unavailable. */
    }
  }
  return null;
}
